<template>
  <div>
    <template v-for="(item, index) in menus">
      <v-list-group
        v-if="item.type == 'group' && isVisible(item)"
        :key="index"
        :prepend-icon="item.icon"
      >
        <template v-slot:activator>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </template>

        <v-list-item
          v-for="(child, childIndex) in item.children"
          :key="childIndex"
          class="vertical-nav-menu-link"
          active-class="bg-gradient-primary white--text"
          :to="
            child.type == 'page'
              ? '/pages/' + child.page
              : child.type == 'route'
              ? child.url
              : null
          "
          @click="openUrl(child.type, child.url)"
        >
          <v-list-item-icon>
            <v-icon small class="vertical-nav-menu-link-subicon"
              >mdi-checkbox-blank-circle-outline</v-icon
            >
          </v-list-item-icon>
          <v-list-item-title>{{ child.title }}</v-list-item-title>
        </v-list-item>
      </v-list-group>

      <v-list-item
        v-else-if="isVisible(item)"
        :key="index + 'x'"
        class="vertical-nav-menu-link"
        active-class="bg-gradient-primary white--text"
        :to="
          item.type == 'page'
            ? '/pages/' + item.page
            : item.type == 'route'
            ? item.url
            : null
        "
        @click="openUrl(item.type, item.url)"
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item>
    </template>
  </div>
</template>

<script>
import { openUrl } from "../../../utils/helper";
import { mapState } from "pinia";
import { useUserStore } from "../../../store/user";

export default {
  props: ["menus"],

  computed: {
    ...mapState(useUserStore, ["signedin", "isAdmin"]),
  },

  methods: {
    openUrl,
    isVisible(item) {
      if (item.signedin === true && !this.signedin) return false;
      if (item.isAdmin === true && !this.isAdmin) return false;
      return true;
    },
  },
};
</script>